import { Outlet } from 'react-router-dom';

const ApprovalAuth = () => {
  return <Outlet />;
};

export default ApprovalAuth;
